import { isAxiosError } from 'axios'

import { isRetriable } from './isRetriable'

export const shouldRetry = (retryCount: number, error: unknown) => {
  if (!isAxiosError(error)) {
    return false
  }

  if (retryCount >= 3) {
    return false
  }

  return isRetriable(error.response?.status)
}
